// src/components/DetailLayout.js
import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./DetailLayout.css";

/**
 * Shared "article" shell for project / certificate / blog post detail pages,
 * so the three read as one consistent reading experience.
 */
const DetailLayout = ({
  backTo,
  backLabel = "Back",
  coverImage,
  eyebrow,
  title,
  meta = [],
  children,
  cta,
}) => (
  <article className="detail-page">
    <div className="container detail-page__inner">
      <Link to={backTo} className="detail-page__back">
        <FaArrowLeft size={12} /> {backLabel}
      </Link>

      {coverImage && (
        <div className="detail-page__cover">
          <img src={coverImage} alt={title} loading="lazy" />
        </div>
      )}

      <header className="detail-page__header">
        {eyebrow && <p className="section-label">{eyebrow}</p>}
        <h1 className="detail-page__title">{title}</h1>
        {meta.length > 0 && (
          <div className="detail-page__meta">
            {meta.map((m, i) => (
              <span key={i} className="detail-page__meta-item">{m}</span>
            ))}
          </div>
        )}
      </header>

      <div className="detail-page__body">{children}</div>

      {cta && <footer className="detail-page__cta">{cta}</footer>}
    </div>
  </article>
);

export default DetailLayout;
